import {AirportSelection, AirportTooltipInfoField} from '../common/enums';
import {DropdownItems} from '../components/weather/settings/settings-options';
import {UnitFormatter} from '../formatters';
import {FeNavAirport} from './nav-types';

export type AirportTooltipFieldSelection = AirportSelection | AirportTooltipInfoField;

export const airportSelectionFields: Partial<Record<AirportSelection, { name: string }>> = {
    [AirportSelection.Notes]: {name: 'Notes'},
    [AirportSelection.iataId]: {name: 'IATA ID'},
    [AirportSelection.icaoId]: {name: 'ICAO ID'},
    [AirportSelection.MonStatApt]: {name: 'MonStatApt'},
    [AirportSelection.metarFc]: {name: 'Flt Cat (MET)'},
    [AirportSelection.metarVis]: {name: 'Visibility (MET)'},
    [AirportSelection.metarCeil]: {name: 'Ceiling (MET)'},
    [AirportSelection.metarWs]: {name: 'Wind (MET)'},
    [AirportSelection.metarWg]: {name: 'Gusts (MET)'},
    [AirportSelection.metarTmp]: {name: 'Temp (MET)'},
    [AirportSelection.metarAltimeter]: {name: 'Altimeter (MET)'},
    [AirportSelection.taf]: {name: 'TAF'},
    [AirportSelection.rvrWc]: {name: 'RVR-WC'},
    [AirportSelection.fltholdinginto]: {name: 'Flts Hldng Into'},
    [AirportSelection.gndStp]: {name: 'Gnd stop'},
    [AirportSelection.gndDelay]: {name: 'Gnd delay'},
    [AirportSelection.clFaa]: {name: 'Closure (FAA)'},
    [AirportSelection.depDel]: {name: 'Dep Delay'},
    [AirportSelection.arrDel]: {name: 'Arr Delay'},
    [AirportSelection.ArrRate]: {name: 'ArrRate'},
    [AirportSelection.ArrRWays]: {name: 'ArrRWays'},
    [AirportSelection.closureAltPS]: {name: 'Alt (P/S)'},
    [AirportSelection.closureAltAct]: {name: 'Alt (act)'},
    [AirportSelection.closuredm]: {name: 'Closure (DM)'},
    [AirportSelection.closurestart]: {name: 'Closure Start (DM)'},
    [AirportSelection.closureend]: {name: 'Closure End (DM)'},
    [AirportSelection.closureDestPS]: {name: 'Dest (P/S)'},
    [AirportSelection.closureDestAct]: {name: 'Dest (act)'},
    [AirportSelection.DepRate]: {name: 'DepRate'},
    [AirportSelection.Deicing]: {name: 'De-icing'},
    [AirportSelection.DepRWays]: {name: 'DepRWays'},
    [AirportSelection.metarWd]: {name: 'Wind Dir (MET)'},
    [AirportSelection.metarDew]: {name: 'Dew Pt (MET)'},
    [AirportSelection.metartime]: {name: 'METAR time'},
    [AirportSelection.taftime]: {name: 'TAF time'},
    [AirportSelection.diversioncapacityairlinenarrow]: {name: 'Div Cap Air Narr'},
    [AirportSelection.diversioncapacityairlinewide]: {name: 'Div Cap Air Wide'},
    [AirportSelection.diversioncapacitynetworknarrow]: {name: 'Div Cap Net Narr'},
    [AirportSelection.diversioncapacitynetworkwide]: {name: 'Div Cap Net Wide'},
    [AirportSelection.diversioncapacityothernarrow]: {name: 'Div Cap Othr Narr'},
    [AirportSelection.diversioncapacityotherwide]: {name: 'Div Cap Othr Wide'},
    [AirportSelection.diversiondivertairlinenarrow]: {name: 'Div Act Air Narr'},
    [AirportSelection.diversiondivertairlinewide]: {name: 'Div Act Air Wide'},
    [AirportSelection.diversiondivertnetworknarrow]: {name: 'Div Act Net Narr'},
    [AirportSelection.diversiondivertnetworkwide]: {name: 'Div Act Net Wide'},
    [AirportSelection.diversiondivertothernarrow]: {name: 'Div Act Othr Narr'},
    [AirportSelection.diversiondivertotherwide]: {name: 'Div Act Othr Wide'},
    [AirportSelection.diversionavailableairlinenarrow]: {name: 'Div Avl Air Narr'},
    [AirportSelection.diversionavailableairlinewide]: {name: 'Div Avl Air Wide'},
    [AirportSelection.diversionavailablenetworknarrow]: {name: 'Div Avl Net Narr'},
    [AirportSelection.diversionavailablenetworkwide]: {name: 'Div Avl Net Wide'},
    [AirportSelection.diversionavailableothernarrow]: {name: 'Div Avl Othr Narr'},
    [AirportSelection.diversionavailableotherwide]: {name: 'Div Avl Othr Wide'},
    [AirportSelection.diversioncomments]: {name: 'Div Man Comments'},
    [AirportSelection.diversioncapacityairlinetotal]: {name: 'Div Cap Air Tot'},
    [AirportSelection.diversioncapacitynetworktotal]: {name: 'Div Cap Net Tot'},
    [AirportSelection.diversioncapacityothertotal]: {name: 'Div Cap Othr Tot'},
    [AirportSelection.diversiondivertairlinetotal]: {name: 'Div Act Air Tot'},
    [AirportSelection.diversiondivertnetworktotal]: {name: 'Div Act Net Tot'},
    [AirportSelection.diversiondivertothertotal]: {name: 'Div Act Othr Tot'},
    [AirportSelection.diversionavailableairlinetotal]: {name: 'Div Avl Air Tot'},
    [AirportSelection.diversionavailablenetworktotal]: {name: 'Div Avl Net Tot'},
    [AirportSelection.diversionavailableothertotal]: {name: 'Div Avl Othr Tot'},
    [AirportSelection.MonStatOrg]: {name: 'MonStatOrg'},
    [AirportSelection.MonStatDst]: {name: 'MonStatDst'},
    [AirportSelection.MonStatAlt]: {name: 'MonStatAlt'}
};

export const airportInfoFields: Record<AirportTooltipInfoField, { name: string }> = {
    [AirportTooltipInfoField.AptType]: {name: 'Type'},
    [AirportTooltipInfoField.MagVar]: {name: 'MagVar'},
    [AirportTooltipInfoField.Elevation]: {name: 'Elevation'},
    [AirportTooltipInfoField.Use]: {name: 'Use'},
    [AirportTooltipInfoField.ControlTower]: {name: 'Control tower'},
    [AirportTooltipInfoField.IcaoArff]: {name: 'ICAO ARFF'},
    [AirportTooltipInfoField.FaaArff]: {name: 'FAA ARFF'}
};

export const airportFieldsOptions: DropdownItems<AirportTooltipFieldSelection> = [
    ...Object.entries(airportSelectionFields).map(([key, value]) => ({
        value: +key as AirportSelection,
        text: value.name
    })),
    ...Object.entries(airportInfoFields).map(([key, value]) => ({
        value: key as AirportTooltipInfoField,
        text: value.name
    }))
].toSorted((a, b) => a.text.localeCompare(b.text));

export default airportSelectionFields;

export function formatAirportInfoField(airport: FeNavAirport, field: AirportTooltipInfoField): string {
    switch (field) {
        case AirportTooltipInfoField.AptType:
            return formatAptType(airport.apttype);
        case AirportTooltipInfoField.MagVar:
            return airport.magvar != null ? `${airport.magvar}°` : 'Unknown';
        case AirportTooltipInfoField.Elevation:
            return UnitFormatter.formatDistanceFromFeet(airport.elevation) || 'Unknown';
        case AirportTooltipInfoField.Use:
            return formatUse(airport.pubmil, airport.pubpri);
        case AirportTooltipInfoField.ControlTower:
            return airport.ct ? 'Yes' : !airport.ct ? 'No' : 'Unknown';
        case AirportTooltipInfoField.IcaoArff:
            return airport.icaoarff || '-';
        case AirportTooltipInfoField.FaaArff:
            return airport.faaarff || '-';
        default:
            return '-';
    }
}

function formatAptType(apttype: string): string {
    switch (apttype) {
        case 'A':
            return 'Aerodrome';
        case 'B':
            return 'Balloon port';
        case 'G':
            return 'Glider port';
        case 'H':
            return 'Heliport';
        case 'S':
            return 'Seaport';
        case 'U':
            return 'Ultralight';
        default:
            return 'Unknown';
    }
}

function formatUse(pubmil: string, pubpri: number): string {
    let publicMilitary: string;
    switch (pubmil) {
        case 'C':
            publicMilitary = 'Civil';
            break;
        case 'M':
            publicMilitary = 'Military';
            break;
        case 'B':
            publicMilitary = 'Both';
            break;
        default:
            publicMilitary = 'Unknown';
    }

    const publicPrivate = pubpri === 0 ? 'Public' : pubpri === 1 ? 'Private' : 'Unknown';

    return `${publicMilitary}/${publicPrivate}`;
}
